export default __webpack_public_path__ + "static/Novelcraft-c5ca9680a5df9d64e4822d3560012b31.webp";